import { OutlineSection } from 'react-scale/remotasks.com/components/Expert/OutlinePanel';
import {
  useGetOutlineNodeStatus,
  useIsInTraining,
  useProjectOutlineStore,
} from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/stores/projectOutlineStore';
import { CourseStepConfig } from '@scale/shared/onboardingControlPanel';
import { ProjectOutlineSectionStatus } from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/components/ProjectOutlineSectionStatus';
import { ProjectOutlineNodeStatus } from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/types';
import { analytics } from 'react-scale/lib/analytics/segment-source-scalers';
import { getPageLoadSingleton } from '@scale/frontend-lib/globalSingletons';
import _ from 'lodash';
import { Tag } from '@scale/scaleui';
import { CourseType } from '@scale/shared/defaults';

type CourseOutlineSectionProps = {
  node: CourseStepConfig;
  loading: boolean;
  setCurrentSectionIndex?: (index: number) => void;
};

export const CourseOutlineSection = ({
  node,
  loading,
  setCurrentSectionIndex,
}: CourseOutlineSectionProps) => {
  const courseMap = useProjectOutlineStore(state => state.courseMap);
  const setCurrentNodeIndex = useProjectOutlineStore(state => state.setCurrentNodeIndex);
  const { status, selected, nodeIndex } = useGetOutlineNodeStatus(node);
  const isInTraining = useIsInTraining();
  const course = courseMap[node.courseId];

  const handleClick = () => {
    if (status !== ProjectOutlineNodeStatus.NOT_STARTED) {
      // If we are in training, clicking on the course header can
      // move the outline to the selected course
      if (isInTraining) {
        setCurrentNodeIndex(nodeIndex);
        analytics.track('Project onboarding', {
          pageLoadId: getPageLoadSingleton(),
        });
      } else {
        analytics.track('Project onboarding', {
          pageLoadId: getPageLoadSingleton(),
        });
        // If not, we will open the course in a new tab
        window.open(`/expert/course?id=${node.courseId}&readOnly=true`, '_blank');
      }
    }
  };

  return (
    <OutlineSection
      title={
        <div className="flex gap-1 items-center">
          <span className="text-neutral-700">{course.title ?? ''}</span>
          {!_.isNil(course.courseDuration) && course.courseType !== CourseType.Certification && (
            <>
              <span className="text-[0.675rem] text-neutral-700">•</span>
              <span className="text-[0.675rem] text-neutral-700">{`${course.courseDuration}m`}</span>
            </>
          )}
          {course.courseType === CourseType.Certification && (
            <Tag variant="warning" size="sm">
              Graded
            </Tag>
          )}
        </div>
      }
      steps={[]}
      active={selected}
      muted={status === ProjectOutlineNodeStatus.NOT_STARTED}
      onHeaderClick={handleClick}
      loading={loading}
      setCurrentSectionIndex={setCurrentSectionIndex}
      titleEndAdornment={<ProjectOutlineSectionStatus status={status} />}
    />
  );
};
